import { useState, useEffect } from 'react';
import { BrandIcon, BrandName } from '@/components/base/BrandMark';

export default function LoadingScreen() {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    let maxTimeoutId: ReturnType<typeof setTimeout>;

    const handleLoaded = () => {
      // Petit delai pour laisser le rendu se stabiliser
      timeoutId = setTimeout(() => {
        setFadeOut(true);
        // Attendre la fin de l'animation fade-out avant de retirer du DOM
        setTimeout(() => setIsVisible(false), 500);
      }, 300);
    };

    // Si la page est deja chargee (cache navigateur)
    if (document.readyState === 'complete') {
      handleLoaded();
    } else {
      window.addEventListener('load', handleLoaded, { once: true });
    }

    // Securite : timeout max 4 secondes dans tous les cas
    maxTimeoutId = setTimeout(() => {
      handleLoaded();
    }, 4000);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(maxTimeoutId);
      window.removeEventListener('load', handleLoaded);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-brand-cream transition-opacity duration-500 ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
      aria-label="Chargement de la page"
      role="status"
    >
      <div className="flex flex-col items-center gap-6">
        {/* Logo + nom */}
        <div className="flex items-center gap-3">
          <BrandIcon size="w-12 h-12" textSize="text-lg" />
          <BrandName className="font-heading text-2xl font-bold text-brand-black tracking-wide" />
        </div>

        {/* Spinner */}
        <div className="relative w-10 h-10">
          <div className="absolute inset-0 rounded-full border-2 border-brand-gold/20" />
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-brand-gold animate-spin" />
        </div>

        <p className="text-sm text-brand-black/40 font-medium tracking-wide">
          Chargement en cours...
        </p>
      </div>
    </div>
  );
}